export enum RippleEffectShapeEnum {
  CIRCLE,
  BUTTON,
  RECTANGLE,
  RADIUS_16,
}
